module.exports = __webpack_public_path__ + "img/back.184e2b4e.svg";